import { insight001 } from "./insights/insight-001";
import { insight002 } from "./insights/insight-002";
import { insight003 } from "./insights/insight-003";
import { insight004 } from "./insights/insight-004";
import { insight005 } from "./insights/insight-005";
import { insight006 } from "./insights/insight-006";
import { insight007 } from "./insights/insight-007";
import { insight008 } from "./insights/insight-008";
import { insight009 } from "./insights/insight-009";
import { insight010 } from "./insights/insight-010";
import { insight011 } from "./insights/insight-011";
import { insight012 } from "./insights/insight-012";
import { insight013 } from "./insights/insight-013";
import { insight014 } from "./insights/insight-014";
import { insight015 } from "./insights/insight-015";
import { insight016 } from "./insights/insight-016";
import { insight017 } from "./insights/insight-017";
import { insight018 } from "./insights/insight-018";
import { insight019 } from "./insights/insight-019";
import { insight020 } from "./insights/insight-020";
import { insight021 } from "./insights/insight-021";
import { insight022 } from "./insights/insight-022";
import { insight023 } from "./insights/insight-023";
import { insight024 } from "./insights/insight-024";
import { insight025 } from "./insights/insight-025";
import { insight026 } from "./insights/insight-026";
import { insight027 } from "./insights/insight-027";
import { insight028 } from "./insights/insight-028";
import { insight029 } from "./insights/insight-029";
import { insight030 } from "./insights/insight-030";
import { insight031 } from "./insights/insight-031";
import { insight032 } from "./insights/insight-032";
import { insight033 } from "./insights/insight-033";
import { insight034 } from "./insights/insight-034";
import { insight035 } from "./insights/insight-035";
import { insight036 } from "./insights/insight-036";
import { insight037 } from "./insights/insight-037";
import { insight038 } from "./insights/insight-038";
import { insight039 } from "./insights/insight-039";
import { insight040 } from "./insights/insight-040";
import { insight041 } from "./insights/insight-041";
import { insight042 } from "./insights/insight-042";
import { insight043 } from "./insights/insight-043";
import { insight044 } from "./insights/insight-044";
import { insight045 } from "./insights/insight-045";
import { insight046 } from "./insights/insight-046";
import { insight047 } from "./insights/insight-047";
import { insight048 } from "./insights/insight-048";
import { insight049 } from "./insights/insight-049";
import { insight050 } from "./insights/insight-050";
import { insight051 } from "./insights/insight-051";
import { insight052 } from "./insights/insight-052";
import { insight053 } from "./insights/insight-053";
import { insight054 } from "./insights/insight-054";
import { insight055 } from "./insights/insight-055";
import { insight056 } from "./insights/insight-056";
import { insight057 } from "./insights/insight-057";
import { insight058 } from "./insights/insight-058";
import { insight059 } from "./insights/insight-059";
import { insight060 } from "./insights/insight-060";
import { insight061 } from "./insights/insight-061";
import { insight062 } from "./insights/insight-062";
import { insight063 } from "./insights/insight-063";
import { insight064 } from "./insights/insight-064";
import { insight065 } from "./insights/insight-065";
import { insight066 } from "./insights/insight-066";
import { insight067 } from "./insights/insight-067";
import { insight068 } from "./insights/insight-068";
import { insight069 } from "./insights/insight-069";
import { insight070 } from "./insights/insight-070";
import { insight071 } from "./insights/insight-071";
import { insight072 } from "./insights/insight-072";
import { insight073 } from "./insights/insight-073";
import { insight074 } from "./insights/insight-074";
import { insight075 } from "./insights/insight-075";
import { insight076 } from "./insights/insight-076";
import { insight077 } from "./insights/insight-077";
import { insight078 } from "./insights/insight-078";
import { insight079 } from "./insights/insight-079";
import { insight080 } from "./insights/insight-080";
import { insight081 } from "./insights/insight-081";
import { insight082 } from "./insights/insight-082";
import { insight083 } from "./insights/insight-083";
import { insight084 } from "./insights/insight-084";
import { insight085 } from "./insights/insight-085";
import { insight086 } from "./insights/insight-086";
import { insight088 } from "./insights/insight-088";
import { insight089 } from "./insights/insight-089";
import { insight090 } from "./insights/insight-090";
import { insight091 } from "./insights/insight-091";
import { insight092 } from "./insights/insight-092";
import { insight093 } from "./insights/insight-093";
import { insight094 } from "./insights/insight-094";
import { insight095 } from "./insights/insight-095";
import { insight096 } from "./insights/insight-096";
import { insight097 } from "./insights/insight-097";
import { insight098 } from "./insights/insight-098";
import { insight099 } from "./insights/insight-099";
import { insight100 } from "./insights/insight-100";
import { insight101 } from "./insights/insight-101";
import { insight102 } from "./insights/insight-102";
import { insight103 } from "./insights/insight-103";
import { insight104 } from "./insights/insight-104";
import { insight105 } from "./insights/insight-105";
import { insight106 } from "./insights/insight-106";
import { insight107 } from "./insights/insight-107";
import { insight108 } from "./insights/insight-108";
import { insight109 } from "./insights/insight-109";
import { insight110 } from "./insights/insight-110";
import { insight111 } from "./insights/insight-111";
import { insight112 } from "./insights/insight-112";
import { insight113 } from "./insights/insight-113";
import { insight114 } from "./insights/insight-114";
import { insight115 } from "./insights/insight-115";
import { insight116 } from "./insights/insight-116";
import { insight117 } from "./insights/insight-117";
import { insight118 } from "./insights/insight-118";

export const events = [
  insight057,
  insight021,
  insight022,
  insight020,
  insight019,
  insight017,
  insight016,
  insight012,
  insight010,
];

export const weekly = [
  insight118,
  insight117,
  insight116,
  insight115,
  insight114,
  insight113,
  insight112,
  insight110,
  insight109,
  insight108,
  insight107,
  insight106,
  insight104,
  insight103,
  insight102,
  insight100,
  insight098,
  insight096,
  insight095,
  insight094,
  insight093,
  insight091,
  insight089,
  insight088,
  insight086,
  insight085,
  insight084,
  insight082,
  insight079,
  insight078,
  insight077,
  insight076,
  insight074,
  insight073,
  insight072,
  insight071,
  insight067,
  insight066,
  insight065,
  insight064,
  insight062,
  insight061,
  insight060,
  insight059,
  insight058,
  insight056,
  insight055,
  insight054,
  insight053,
  insight052,
  insight051,
  insight050,
  insight049,
  insight048,
  insight047,
  insight046,
  insight045,
  insight044,
  insight043,
  insight042,
  insight041,
  insight040,
  insight039,
  insight038,
  insight037,
  insight036,
  insight035,
  insight033,
  insight032,
  insight031,
  insight030,
  insight029,
  insight028,
  insight027,
  insight026,
];

export const insights = [
  insight111,
  insight105,
  insight101,
  insight099,
  insight097,
  insight092,
  insight090,
  insight083,
  insight081,
  insight080,
  insight075,
  insight069,
  insight070,
  insight068,
  insight063,
  insight034,
  insight025,
  insight024,
  insight023,
  insight018,
  insight015,
  insight014,
  insight013,
  insight011,
  insight009,
  insight008,
  insight007,
  insight006,
  insight005,
  insight004,
  insight003,
  insight002,
  insight001,
];
